module.exports = "pegasus_template/assets/preview-2.png";